import React, { useState, useEffect } from 'react';
import moment from 'moment-jalaali';// وارد کردن تابع تبدیل تاریخ


const InvoiceForm = () => {
  const [invoiceDate, setInvoiceDate] = useState('');
  const [invoiceDateSH, setInvoiceDateSH] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerMobile, setCustomerMobile] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [discountPercent, setDiscountPercent] = useState('');
  const [discount, setDiscount] = useState('');
  const [tax, setTax] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [paidAmount, setPaidAmount] = useState('');
  const [payStatus, setPayStatus] = useState('');
  const [description, setDescription] = useState('');
  const [items, setItems] = useState([]);

 
  const handleItemChange = (e, index) => {
    const { name, value } = e.target;
    const newItems = [...items];
    newItems[index] = { ...newItems[index], [name]: value };


        // محاسبه Total Price
        if (name === 'quantity' || name === 'unitPrice') {
          const quantity = parseFloat(newItems[index].quantity) || 0;
          const unitPrice = parseFloat(newItems[index].unitPrice) || 0;
          newItems[index].totalPrice = quantity * unitPrice;
        }

    setItems(newItems);
  };

  const addItem = () => {
    setItems([
      ...items,
      {
        productId: '',
        productName: '',
        quantity: '',
        unitPrice: '',
        discountPercent: '',
        discount: '',
        taxPercent: '',
        tax: '',
        totalPrice: '',
        description: ''
      }
    ]);
  };

  const removeItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const invoiceData = {
      invoiceDate,
      invoiceDateSH,
      customerId,
      customerName,
      customerMobile,
      customerAddress,
      discountPercent,
      discount,
      tax,
      totalAmount,
      paidAmount,
      payStatus,
      description,
      items
    };

    try {
      const response = await fetch('https://api2.raynogroup.com/api/invoice', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(invoiceData),
      });

      const result = await response.json();
      if (response.ok) {
        alert(`Invoice created successfully! Invoice Number: ${result.invoiceNumber}`);
      } else {
        alert('Failed to create invoice.');
        console.error(result.errors);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred while creating the invoice.');
    }
  };



    // تبدیل تاریخ میلادی به شمسی
    useEffect(() => {
      if (invoiceDate) {
        const convertedDate = moment(invoiceDate).format('jYYYY/jMM/jDD'); // تبدیل تاریخ میلادی به شمسی
        setInvoiceDateSH(convertedDate);
      }
    }, [invoiceDate]);


  return (
    <div className="container mt-5">
      <h2>ثبت سفارش</h2>

      <form onSubmit={handleSubmit}>
        {/* Invoice Details */}
        <div className="form-group">
          <label>تاریخ میلادی</label>
          <input
            type="date"
            className="form-control"
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>تاریخ شمسی:</label>
          <input
            type="text"
            className="form-control"
            value={invoiceDateSH}
            onChange={(e) => setInvoiceDateSH(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>کد شخص:</label>
          <input
            type="number"
            className="form-control"
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>نام شخص:</label>
          <input
            type="text"
            className="form-control"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>درصد تخفیف:</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={discountPercent}
            onChange={(e) => setDiscountPercent(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>مبلغ تخفیف:</label>
          <input
            type="number"
            className="form-control"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>مالیات:</label>
          <input
            type="number"
            className="form-control"
            value={tax}
            onChange={(e) => setTax(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>جمع کل:</label>
          <input
            type="number"
            className="form-control"
            value={totalAmount}
            onChange={(e) => setTotalAmount(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>مبلغ پرداختی:</label>
          <input
            type="number"
            className="form-control"
            value={paidAmount}
            onChange={(e) => setPaidAmount(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>وضعیت تسویه:</label>
          <input
            type="number"
            className="form-control"
            value={payStatus}
            onChange={(e) => setPayStatus(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>توضیحات:</label>
          <textarea
            className="form-control"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        {/* Items Table */}
        <h3>اقلام سفارش</h3>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>کد کالا</th>
              <th>نام کالا</th>
              <th>تعداد</th>
              <th>فی</th>
              <th>تخفیف%</th>
              <th>مبلغ تخفیف</th>
              <th>مالیات%</th>
              <th>مبلغ مالیات</th>
              <th>جمع کل</th>
              <th>توضیحات</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="number"
                    name="productId"
                    className="form-control"
                    value={item.productId}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="productName"
                    className="form-control"
                    value={item.productName}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="quantity"
                    className="form-control"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="unitPrice"
                    className="form-control"
                    value={item.unitPrice}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="discountPercent"
                    step="0.01"
                    className="form-control"
                    value={item.discountPercent}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="discount"
                    className="form-control"
                    value={item.discount}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="taxPercent"
                    step="0.01"
                    className="form-control"
                    value={item.taxPercent}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="tax"
                    className="form-control"
                    value={item.tax}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="totalPrice"
                    className="form-control"
                    value={item.totalPrice}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="description"
                    className="form-control"
                    value={item.description}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => removeItem(index)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <button type="button" className="btn btn-success mb-3" onClick={addItem}>
          اضافه کردن سطر
        </button>
        <p/>
        {/* Submit Button */}
        <button type="submit" className="text-start btn btn-primary">ثبت سفارش</button>
        <p/>
      </form>
    </div>
  );
};

export default InvoiceForm;
